module.exports = __webpack_public_path__ + "img/logo_bucuresti_2050_text_cu-subtitlu_monocrom.8cbd5232.svg";